// extracted by mini-css-extract-plugin
export var copyIcon = "_rn-2";
export var discountCard = "_rn-0";
export var discountCode = "_rn-3";
export var discountContent = "_rn-1";
export var loadingCard = "_rn-4";